import { PhotoSize } from '@alltrails/shared/types/photos';

export type PhotoSizeClassName = 'lg-sq' | 'sm' | 'lg';

/**
 * Translates the photo size enum to a global classname based on the photos index position.
 * Used for rendering a dynamically sized photo gallery.
 * @param photoSize photo size (enum) value to translate
 * @param idx index of the photo
 * @param dynamicPhotoSizes toggle for returning dynamic sized classes
 * @returns classname as a string
 */
export default function getSizeClass(photoSize: PhotoSize, idx: number, dynamicPhotoSizes?: boolean): PhotoSizeClassName {
  if (photoSize === 'large_square' && !dynamicPhotoSizes) {
    return 'lg-sq';
  }
  const pos = idx % 7;
  return pos < 4 ? 'sm' : 'lg';
}
